import ApiHelper from "../../helpers/ApiHelper";
import GeneralHelper from "../../helpers/GeneralHelper";
import BaseService from "../BaseService";

class NotificationService extends BaseService {

    static url = "customers/notifications";
    static apis = {
        that: this,
        get: function() {
            return this.that.url;
        },

        markSeen: function(id) {
            return this.that.url + "/" + id;
        },

        count: function() {
            return this.that.url + "/count-notification"
        },

        markAllSeen: function(){
            return this.that.url + "/all"
        },

        deleteNotification: function(id) { 
            return this.that.url + "/" + id;
        },

        getEmailTypes: function(){
            return this.that.url + '/email-types'
        },
        editPreferences:function(){
            return this.that.url  +'/edit-preferences'
        }, 

    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("customers");
    }

    markSeen(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: NotificationService.apis.markSeen(id),
                    method: "PUT",
                    showLoader: true,
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    deleteNotification(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: NotificationService.apis.deleteNotification(id),
                    method: "DELETE",
                    showLoader: true,
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    markAllSeen() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: NotificationService.apis.markAllSeen(),
                    method: "POST",
                    showLoader: true,
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    get() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: NotificationService.apis.get(),
                    method: "GET",
                    showLoader: true,
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    count() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: NotificationService.apis.count(),
                    method: "GET",
                    showLoader: true,
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getEmailTypes() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: NotificationService.apis.getEmailTypes(),
                    method: "GET",
                    showLoader: true,
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    EditPreferences(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: NotificationService.apis.editPreferences(),
                    method: "POST",
                    data: data,
                    showLoader: true,
                    authorization: true,
                    message: {
                        success: GeneralHelper.buildMessage(1, "Successfully updated!")
                    }
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getKeywords() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: NotificationService.apis.getKeywords(),
                    method: "GET",
                    showLoader: true,
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}

export default NotificationService;